

import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import { Select2OptionData } from 'ng-select2';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { CreateResult } from '../models/create-result';
import { ParticipantViewModel } from '../models/participant-view-model';
import { ParticipantService } from '../services/participant.service';
import { AuthenticationService } from '../services/authentication.service';
import { UserDataStoreService } from '../services/user-data-store.service';
import { PermissionEnum } from '../services/guards/permissions';
import { CardSetsViewModel } from '../models/card-set';
import { MerchantService } from '../services/merchant.service';
import { CustomTagParticipantLinkViewModel } from '../models/card-set-participant-link';
import {CardAcceptorConfigViewModel} from '../models/card-acceptor-config-view-model';
import {ConfirmationDialogComponent} from '../partials/confirmation-dialog/confirmation-dialog.component';
import { CardAcceptorConfigService } from '../services/card-acceptor-config.service';
import { CustomTagService } from "../services/custom-tag.service";
import { CustomTagsParticipantLinkViewModel } from '../models/custom-tags-participant-link';
import { NgxUiLoaderService } from 'ngx-ui-loader';


@Component({
  selector: 'custom-tags-mapping-view',
  templateUrl: './custom-tags-view.component.html',
  styleUrls: ['./custom-tags-view.component.scss']
})
export class CustomTagsViewComponent implements OnInit {

  public customTags: Select2OptionData[];
  public allsinkNodes: Select2OptionData[];
  public mapCustomTags: Select2OptionData[];

  public participant: ParticipantViewModel;
  public customTagsByParticipant: CustomTagsParticipantLinkViewModel[] = [];

  public createResult: CreateResult;
  public canEdit: boolean;
  errorMessage: string;
  error: boolean;
  public selectedCustomTag: string;

  public select2options: any = {
    multiple: false,
    width: '100%',
    allowClear: true
  };

  constructor(private _modalService: NgbModal,
    private _cardAcceptorConfigService: CardAcceptorConfigService,
    private _customTagService: CustomTagService,
    private _participantService: ParticipantService,
    private _merchantService: MerchantService,
    private _authenticationService: AuthenticationService,
    private _toastService: ToastrService,
    private _userDataStore: UserDataStoreService,
    private _route: ActivatedRoute,
    private _ngxUiLoaderService: NgxUiLoaderService) {
    this._route.params.subscribe(async params => {
      this.canEdit = this._userDataStore.hasRequiredPermissions([PermissionEnum.EditParticipantConfiguration], []);
      await this.initParticipant(params.id);
      this.customTags = (await this._customTagService.GetCustomTags()).map((x) => {
        return { id: x.tag.toString(), text: x.tag }
      });
      this.customTagsByParticipant = await this._customTagService.GetCustomTagsByParticipantId(this.participant.id);
      this.filterCustomTags();
    });
  }

  public async ngOnInit(): Promise<void> {

  }

  public async initParticipant(id: number): Promise<void> {
    this.participant = await this._participantService.GetParticipant(id);
  }

  public filterCustomTags(): void {
    const filteredItems = this.customTags.filter((item) => {
      if (this.customTagsByParticipant != null) {
        const index = this.customTagsByParticipant.findIndex(x => x.customTag.toString() === item.text);
        if (index > -1) {
          return false;
        }
      }
      return true;
    });
    this.mapCustomTags = filteredItems;
  }

  public async save(): Promise<void> {

    if (!this.canEdit) {
      this._toastService.error('You do not have the required permissions to perform this action.', 'Error');
    } else {

      this.createResult = await this._customTagService.DeleteCustomTagsByParticipantId(this.participant.id);

      if (this.createResult.success) {
        this.createResult = await this._customTagService.UpdateCustomTags(this.customTagsByParticipant);
        if (this.createResult.success) {
          this._toastService.success(this.createResult.message, 'Success');
        } else {
          this._toastService.error(this.createResult.message, 'Error');
        }
      }
      else {
        this._toastService.error(this.createResult.message, 'Error');
      }
    }
  }


  public addCustomTagsFields(): void {
    let cardSet: string = this.selectedCustomTag;
    if (cardSet == null) {
      alert('Select a Custom Tag');
    }
    else {
      this.customTagsByParticipant.push({
        customTag: this.selectedCustomTag,
        participantId: this.participant.id,
        groupName: '',
        fileId:''
      });
      this.filterCustomTags();

    }
  }

  public deleteMappedField(customTag: string): void {

    const index = this.customTagsByParticipant.findIndex(x => x.customTag == customTag);

    if (index > -1) {
      this.customTagsByParticipant.splice(index, 1);
    }
    this.filterCustomTags();
  }

  public async determineDeleteDialog(customTag: string) {
    this._ngxUiLoaderService.start();
    var terminals = await this._customTagService.GetTerminalsCountByCustomTags(customTag, this.participant.id);
    this._ngxUiLoaderService.stop();
    if (!!terminals && terminals.length === 0) {
      await this.openDeleteConfirmationDialog(customTag);
    } else {
      await this.openUsedDeleteFailureConfirmationDialog(terminals.length);
    }
  }

  public async openDeleteConfirmationDialog(customTag: string) {

    const dialogRef = this._modalService.open(ConfirmationDialogComponent, {
      windowClass: 'modal-fade-in',
      centered: false,
      size: 'xl',
      backdrop: 'static'
    });
    dialogRef.componentInstance.showCancel = true;
    dialogRef.componentInstance.acceptButtonText = 'Yes';
    dialogRef.componentInstance.cancelButtonText = 'No'
    dialogRef.componentInstance.title = 'Custom Tag Removal'
    dialogRef.componentInstance.message = 'Are you sure you want to delete the selected custom tag?'

    const result = await dialogRef.result;
    if (result) {
      await this.deleteMappedField(customTag);
    }
  }

  public async openUsedDeleteFailureConfirmationDialog(terminalCount: number) {
    const dialogRef = this._modalService.open(ConfirmationDialogComponent, {
      windowClass: 'modal-fade-in',
      centered: false,
      size: 'xl',
      backdrop: 'static'
    });
    dialogRef.componentInstance.acceptButtonText = 'OK'
    dialogRef.componentInstance.title = 'Custom Tag cannot be removed'
    dialogRef.componentInstance.message = `The Custom tag is currently in use by ${terminalCount} terminal(s) and cannot be deleted.`
  }
}

